import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantEmployee from './tenant-employee';
import TenantEmployeeDetail from './tenant-employee-detail';
import TenantEmployeeUpdate from './tenant-employee-update';
import TenantEmployeeDeleteDialog from './tenant-employee-delete-dialog';

const TenantEmployeeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantEmployee />} />
    <Route path="new" element={<TenantEmployeeUpdate />} />
    <Route path=":id">
      <Route index element={<TenantEmployeeDetail />} />
      <Route path="edit" element={<TenantEmployeeUpdate />} />
      <Route path="delete" element={<TenantEmployeeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantEmployeeRoutes;
